export default __webpack_public_path__ + "static/media/email.b3f760ab.svg";